const ROUTE_DEDAND_MANAGE = [
  {path: 'project-manage/demand-manage/demandDetail', meta: { name: "需求详情"}},
  {path: 'project-manage/change-manage/list', meta: { name: "变更管理"}},
  {path: 'project-manage/change-manage/check-list', meta: { name: "变更管理列表"}},
  
]

export default ROUTE_DEDAND_MANAGE


// WEBPACK FOOTER //
// ./src/router/mapping/demand-manage.js